import Vue from 'vue'
import App from './App.vue'
import router from './Routes'
import store from './store/index'
import vuetify from './plugins/vuetify'
// import axios from 'axios'
// import config from "./config";
import * as VueGoogleMaps from 'vue2-google-maps'
import {AuthMixin} from "./mixins/auth"
import { VueMaskDirective } from 'v-mask';

import browserDetect from "vue-browser-detect-plugin";
Vue.use(browserDetect);

Vue.directive('mask', VueMaskDirective);

// axios.defaults.baseURL = config.baseURLApi;
// axios.defaults.headers.common['Content-Type'] = "application/json";
// const token = localStorage.getItem('token');
// if (token) {
//   axios.defaults.headers.common['Authorization'] = "Bearer " + token;
// }

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB7OXmzfQYua_1LEhRdqsoYzyJOPh9hGLg',
  },
});
Vue.mixin(AuthMixin);

Vue.config.productionTip = false;

import VueYandexMetrika from 'vue-yandex-metrika';                               
 
Vue.use(VueYandexMetrika, {
    id: 89227914,
    env: process.env.NODE_ENV,
    options: {
      webvisor: true,
      clickmap: true,
      trackLinks:true,
      accurateTrackBounce:true,
    }
})

new Vue({
  vuetify,
  router,
  render: h => h(App), 
  store
}).$mount('#app');
